export const INSIDE_DRAWER = {
    admin: {
        service_name: "Administración",
        show_drawer: true,
        isOpen: false,
        route: "administracion?servicio=",
    },
    config: {
        service_name: "Configuración",
        show_drawer: true,
        isOpen: false,
        route: "configuracion?servicio=",
    },
    users: {
        service_name: "Usuarios",
        show_drawer: true,
        isOpen: false,
        route: "usuarios",
    },
};

export const Routes = {
    login: {
        route: "/login",
    },
    dashboard: {
        route: "/",
        wordKey: "Home",
        showMenuItem: true,
        needSuperAuth: false,
    },
    usuarios: {
        route: "/usuario",
        wordKey: "Administrativos",
        showMenuItem: true,
        needSuperAuth: false,
    },
    administracion: {
        route: "/administracion",
        wordKey: "Administracion de Usuarios",
        showMenuItem: false,
        needSuperAuth: false,
    },
    dashboardDatosPersonales: {
        route: "/administracion/dashboard-usuarios",
        wordKey: "Datos Personales",
        showMenuItem: false,
        needSuperAuth: false,
    },
    usuariosXServicio: {
        route: "/usuarios-x-servicio",
        wordKey: "Usuarios x servicio",
        showMenuItem: false,
        needSuperAuth: false,
    },
};

export const servicesRoutes = {
    SFHOTEL: [
        {
            route: "/usuarios",
            wordKey: "Usuarios",
            isGroup: false,
            icono: 'Usuario',
        },
        {
            route: "/hoteles",
            wordKey: "Hoteles",
            isGroup: false,
            icono: 'LogoHotel',
        },
        {
            route: "/habitaciones",
            wordKey: "Habitaciones",
            isGroup: false,
            icono: 'Habitacion',
        },
        {
            route: "/ocupacion",
            wordKey: "Ocupación",
            isGroup: false,
            icono: 'Ocupacion',
        },
    ],
};
